// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TSearchPromosRequest, TSearchPromosModel, IMappers, TSearchPromosResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchPromosV2ResponseSchema } from '../../entities/search_promos_v2/SearchPromosV2ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSearchPromosModel(parameters: TSearchPromosRequest): TSearchPromosModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-promos',
    pathApi: '/v2/search-promos/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchPromosOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchPromosRequest;
}

export async function fetchSearchPromos<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchPromosOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSearchPromosResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchPromosModel(parameters),
    config,
  )) as FetchResponse<TSearchPromosResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchPromosV2ResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSearchPromosResponse>;
}
